import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

/** 🎄 Χριστουγεννιάτικα σλόγκαν — το πρώτο μένει σταθερό στην κορυφή της αρχικής. */
export const XMAS_SLOGANS: { text: string; emojis: string }[] = [
  {
    text: "Ήρθαν τα Χριστούγεννα! Λαμπάκια, κεριά & στολίδια σε τιμές MrPanda!",
    emojis: "🐼🎄✨",
  },
  {
    text: "Γέμισε το σπίτι φως: λαμπάκια, κεριά και γιορτινά τραπεζιού 🐼",
    emojis: "✨🕯️🎁",
  },
  {
    text: "Δώρο ετοιμάζεις; Χαρτιά, κορδέλες και γιορτινά σε ένα κλικ!",
    emojis: "🎁🎀🧧",
  },
  {
    text: "Το χριστουγεννιάτικο τραπέζι αρχίζει από εδώ — με τιμές MrPanda!",
    emojis: "🍽️🕯️❄️",
  },
  {
    text: "Ο MrPanda στολίζει μαζί σου: προβολείς, χιονοαλυσίδες & λαμπάκια!",
    emojis: "🌟⛄🐼",
  },
  {
    text: "Από το δέντρο μέχρι το τραπέζι: κάνε γιορτινά όλα τα δωμάτια!",
    emojis: "🎄🕯️✨",
  },
];

/** 🎄 Χριστουγεννιάτικο strip — γιορτινό panel με λαμπιόνια και χιόνι. */
export function ChristmasStrip({
  className,
  index,
}: {
  className?: string;
  /** Σταθερό σλόγκαν· αν λείπει, επιλέγεται τυχαία μετά το hydration. */
  index?: number;
}) {
  const [i, setI] = useState(index != null ? index % XMAS_SLOGANS.length : 0);

  useEffect(() => {
    if (index == null) setI(Math.floor(Math.random() * XMAS_SLOGANS.length));
  }, [index]);

  const slogan = XMAS_SLOGANS[i] ?? XMAS_SLOGANS[0];

  return (
    <section className={cn("px-2 pt-3 md:px-4", className)}>
      <Link
        to="/christmas"
        aria-label="Δες τα χριστουγεννιάτικα είδη"
        className="xmas-panel relative flex flex-wrap items-center justify-center gap-x-4 gap-y-1 overflow-hidden rounded-3xl px-4 py-4 text-center shadow-lg transition-transform hover:scale-[1.01]"
      >
        <span aria-hidden className="pointer-events-none absolute -left-3 -top-4 text-5xl opacity-25">🎄</span>
        <span aria-hidden className="pointer-events-none absolute -bottom-5 -right-2 text-6xl opacity-25">🎁</span>
        <span aria-hidden className="xmas-lights absolute inset-x-0 top-0" />
        <span className="xmas-ribbon hidden rounded-lg px-3 py-1 text-xs font-extrabold sm:inline-block">
          Χριστούγεννα 🎄
        </span>
        <p className="text-base font-extrabold tracking-tight sm:text-lg">{slogan.text}</p>
        <span aria-hidden className="text-lg">{slogan.emojis}</span>
      </Link>
    </section>
  );
}
